// extracted by mini-css-extract-plugin
export default {"contactsBlock":"Contacts_contactsBlock__ury4H","contacts":"Contacts_contacts__8xpKu"};